export const TICK_RATE = 20;
export const TICK_DURATION_MS = 1000 / TICK_RATE;
export const GRID_WIDTH = 24;
export const GRID_HEIGHT = 16;
export const CELL_SIZE = 1;
export const STARTING_GOLD = 200;
export const STARTING_INCOME_PER_SECOND = 4;
export const BASE_MAX_HP = 100;
export const SELL_REFUND_RATIO = 0.7;
export const MAX_TOWER_LEVEL = 4;
export const REBUILD_PROTECTION_TICKS = 10;
export const WAVE_PREPARATION_TICKS = TICK_RATE * 10;
export const WAVE_AUTO_START_TICKS = TICK_RATE * 30;
export const COMEBACK_INCOME_BONUS_MAX = 0.15;
export const COMEBACK_SCORE_GAP_THRESHOLD = 500;
export const MATCH_TIMEOUT_TICKS = TICK_RATE * 60 * 25;
export const COOP_PLAYERS_MAX = 4;
export const ARENA_PLAYERS = 2;
//# sourceMappingURL=balance.js.map